// extracted by mini-css-extract-plugin
module.exports = {"formCard":"FormCard_formCard__3q2tu","cardTitle":"FormCard_cardTitle__6sxXb"};